module.exports = __webpack_public_path__ + "img/gd.gd9357b33.svg";